import { Vector3 } from 'three';

/**
 * Broadcast channel for the visual-only drag preview. DragControls moves the
 * dragged scene objects directly while dragging (no graph updates until drop),
 * so selection wrappers (RectControls and friends) need the live movement to
 * follow along. A null payload means the preview ended or was reset.
 */
export type DragPreviewPayload = {
  selectors: ReadonlySet<string>;
  movement: Vector3;
} | null;

export interface DragPreviewListener {
  (payload: DragPreviewPayload): void;
}

const listeners = new Set<DragPreviewListener>();

export const subscribeDragPreview = (listener: DragPreviewListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const emitDragPreview = (payload: DragPreviewPayload) => {
  listeners.forEach((listener) => listener(payload));
};
